define('lq/viewTransitionManager',[
], function () {

    function ViewTransitionManager() {
        this.viewTransitions = [];
    }

    ViewTransitionManager.prototype.scheduleViewTransition = function (startCallback) {
        var self = this;
        if (document.startViewTransition) {
            return new Promise(function (resolve, reject) {
                self.viewTransitions.push({start: startCallback, resolve: resolve, reject: reject});
                if (self.viewTransitions.length === 1) {
                    self.startViewTransition(self.viewTransitions[0]);
                }
            });
        } else {
            return Promise.resolve(startCallback());
        }
    };

    ViewTransitionManager.prototype.startViewTransition = function (viewTransition) {
        var self = this;
        whenNextFrameOrHidden(function() {
            var updateCallbackDone;
            // WHY: a hidden page gets no frames and no transitions, the update runs right away (like in browsers without view transitions)
            if (document.visibilityState === 'hidden') {
                updateCallbackDone = Promise.resolve().then(viewTransition.start);
            } else {
                var vt = document.startViewTransition(function() {
                    return Promise.resolve().then(viewTransition.start);
                });

                // view transitions are purely cosmetic, so just trying to ignore browser aborts during navigation
                vt.ready.catch(() => {});
                vt.finished.catch(() => {});
                updateCallbackDone = vt.updateCallbackDone;
            }

            // WHY: a failing update must not block the updates after it, it fails only its own caller
            updateCallbackDone
                .then(viewTransition.resolve, viewTransition.reject)
                .then(function() {
                    // Remove the first element the JS way
                    self.viewTransitions.shift();
                    if (self.viewTransitions.length > 0) {
                        self.startViewTransition(self.viewTransitions[0]);
                    }
                });
        });
    };

    // WHY: requestAnimationFrame doesn't fire while the page is hidden (background tab, minimized or covered window),
    // waiting for it would hold back every update until the page is shown again
    function whenNextFrameOrHidden(callback) {
        if (document.visibilityState === 'hidden') {
            callback();
            return;
        }

        var called = false;
        var run = function() {
            if (called) return;
            called = true;
            cancelAnimationFrame(requestId);
            document.removeEventListener('visibilitychange', run);
            callback();
        };
        var requestId = requestAnimationFrame(run);
        document.addEventListener('visibilitychange', run);
    }

    return ViewTransitionManager;
});

